/*
 * Job Listings page/template
 */
export function jobListFilterInit() {
    var functionDropDown = document.querySelector('.job-listings-page select[name="jobs-list-function"]');
    var stateDropDown = document.querySelector('.job-listings-page select[name="jobs-list-state"]');
    var jobs = document.querySelectorAll('.job-listings-page table tbody tr');
    var jobs_table = document.querySelector('.job-listings-page table');
    var no_results = document.querySelector('.job-listings-page .no-results');

    function filterTable() {
        var visible_row_count = 0;

        // Filter each table row
        for ( let i = 0; i < jobs.length; i++ ) {
            var functionRowData = jobs[i].dataset.function;
            var stateRowData = jobs[i].dataset.state;

            // If the function value matches this row, or is set to all
            if ( functionRowData === functionDropDown.value || functionDropDown.value === 'all' ) {
                // And the state value matches this row, or is set to all
                if ( stateRowData === stateDropDown.value || stateDropDown.value === 'all' ) {
                    jobs[i].style.display = "table-row";

                    // Update alternating row colours
                    if ( visible_row_count % 2 === 0 ) {
                        jobs[i].classList.remove('alt-row');
                    }
                    else {
                        jobs[i].classList.add('alt-row');
                    }

                    visible_row_count++;
                }
                else {
                    jobs[i].style.display = "none";
                }
            }
            else {
                jobs[i].style.display = "none";
            }
        }

        if ( visible_row_count === 0 ) {
            jobs_table.style.display = "none";
            no_results.style.display = "block";
        }
        else {
            jobs_table.style.display = "table";
            no_results.style.display = "none";
        }

    }

    if ( functionDropDown && stateDropDown )
    {

        if ( functionDropDown.length && stateDropDown.length ) {
            functionDropDown.addEventListener('change', filterTable);
            stateDropDown.addEventListener('change', filterTable);
        }
    }

}



// WEBPACK FOOTER //
// ./src/js/job_listings.js